module.exports = __webpack_public_path__ + "img/logo1.ec4794b1.png";